import { render, staticRenderFns } from "./FunctionDetail.vue?vue&type=template&id=23575735&scoped=true"
import script from "./FunctionDetail.vue?vue&type=script&lang=js"
export * from "./FunctionDetail.vue?vue&type=script&lang=js"
import style0 from "./FunctionDetail.vue?vue&type=style&index=0&id=23575735&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23575735",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23575735')) {
      api.createRecord('23575735', component.options)
    } else {
      api.reload('23575735', component.options)
    }
    module.hot.accept("./FunctionDetail.vue?vue&type=template&id=23575735&scoped=true", function () {
      api.rerender('23575735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CalculateEditor/FunctionDetail.vue"
export default component.exports